import axios from 'axios'

const baseURL = process.env.BACK_API_URL
const BACK_API = baseURL.split('/api')[0]

const instance = axios.create({
  baseURL: BACK_API,
})

const api = axios.create({
  baseURL,
  onUploadProgress: function (progressEvent) {
    NProgress.set(0.5);
  },
  onDownloadProgress: function (progressEvent) {
    NProgress.set(0.8);
  },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

window.tokenIsRefreshing = false

api.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    const originalConfig = err.config;

    if (err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true
        if (window.tokenIsRefreshing) {
          return;
        }
        window.tokenIsRefreshing = true

        try {
          instance.post("/token", {
            refreshToken: localStorage.getItem("refresh_token")
          }).then(rs => {
            const { access_token, refresh_token } = rs.data;

            if (refresh_token === undefined) {
              localStorage.removeItem("token")
              localStorage.removeItem("refresh_token")
              window.location.href = "/"
              return
            }
            localStorage.setItem("token", access_token);
            localStorage.setItem("refresh_token", refresh_token);

            window.location.reload(true);
          })
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }

      if (err.response.status === 401) {
        return Promise.resolve();
      }
    }

    return Promise.reject(err);
  }
);


export default api



// WEBPACK FOOTER //
// ./src/axiosConnection.js